import { useFeatureFlags } from "./useFeatureFlags";

export const CO_APPROVAL_FLAG = "co-approval-workflow";

export function useCoApprovalEnabled(): boolean {
  return useFeatureFlags().includes(CO_APPROVAL_FLAG);
}
